import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { MESSAGE_LAYOUT_TRANSITION_MS } from '../styles';
import { playFlipTranslateY, prefersReducedMotion } from '../utils/flipTransition';
export const useCenteredEmptyTransition = t0 => {
  const $ = _c(12);
  const {
    isCenteredEmpty,
    shouldCenterWhenEmpty
  } = t0;
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [animateMessageEnter, setAnimateMessageEnter] = useState(false);
  const [emptyContentVisible, setEmptyContentVisible] = useState(isCenteredEmpty);
  const dockRef = useRef(null);
  const prevIsCenteredEmptyRef = useRef(isCenteredEmpty);
  const lastCenteredDockTopRef = useRef(null);
  const lastDockedDockTopRef = useRef(null);
  const transitionTimeoutRef = useRef(null);
  let t1;
  if ($[0] !== isCenteredEmpty) {
    t1 = () => {
      const dockTop = dockRef.current?.getBoundingClientRect().top;
      if (dockTop == null) {
        return;
      }
      if (isCenteredEmpty) {
        lastCenteredDockTopRef.current = dockTop;
      } else {
        lastDockedDockTopRef.current = dockTop;
      }
    };
    $[0] = isCenteredEmpty;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useLayoutEffect(t1);
  let t2;
  let t3;
  if ($[2] !== isCenteredEmpty || $[3] !== shouldCenterWhenEmpty) {
    t2 = () => {
      const wasCenteredEmpty = prevIsCenteredEmptyRef.current;
      prevIsCenteredEmptyRef.current = isCenteredEmpty;
      if (!shouldCenterWhenEmpty) {
        return;
      }
      const clearTransitionTimeout = () => {
        if (transitionTimeoutRef.current != null) {
          window.clearTimeout(transitionTimeoutRef.current);
          transitionTimeoutRef.current = null;
        }
      };
      const finishTransitionLater = onComplete => {
        clearTransitionTimeout();
        setIsTransitioning(true);
        transitionTimeoutRef.current = window.setTimeout(() => {
          setIsTransitioning(false);
          transitionTimeoutRef.current = null;
          onComplete?.();
        }, MESSAGE_LAYOUT_TRANSITION_MS);
      };
      if (prefersReducedMotion()) {
        setEmptyContentVisible(isCenteredEmpty);
        return;
      }
      const dock = dockRef.current;
      if (dock == null) {
        return;
      }
      if (wasCenteredEmpty && !isCenteredEmpty) {
        setEmptyContentVisible(false);
        const firstTop = lastCenteredDockTopRef.current;
        const lastTop = dock.getBoundingClientRect().top;
        if (firstTop != null) {
          finishTransitionLater();
          playFlipTranslateY(dock, firstTop - lastTop);
          setAnimateMessageEnter(true);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              setAnimateMessageEnter(false);
            });
          });
        }
        return;
      }
      if (!wasCenteredEmpty && isCenteredEmpty) {
        setEmptyContentVisible(false);
        const firstTop_0 = lastDockedDockTopRef.current;
        const lastTop_0 = dock.getBoundingClientRect().top;
        if (firstTop_0 != null) {
          finishTransitionLater(() => {
            setEmptyContentVisible(true);
          });
          playFlipTranslateY(dock, firstTop_0 - lastTop_0);
        } else {
          setEmptyContentVisible(true);
        }
      }
    };
    t3 = [isCenteredEmpty, shouldCenterWhenEmpty];
    $[2] = isCenteredEmpty;
    $[3] = shouldCenterWhenEmpty;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useLayoutEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => () => {
      if (transitionTimeoutRef.current != null) {
        window.clearTimeout(transitionTimeoutRef.current);
      }
    };
    t5 = [];
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== animateMessageEnter || $[9] !== emptyContentVisible || $[10] !== isTransitioning) {
    t6 = {
      animateMessageEnter,
      dockRef,
      emptyContentVisible,
      isTransitioning
    };
    $[8] = animateMessageEnter;
    $[9] = emptyContentVisible;
    $[10] = isTransitioning;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};